const PERMISSION = {
	AGENCY: {
		CONTACTS_VIEW: 'CONTACTS.VIEW',
		CONTACTS_CREATE: 'CONTACTS.CREATE',
		CONTACTS_EDIT: 'CONTACTS.EDIT',
		CHANGE_STATUS: 'CONTACTS.CHANGE_STATUS',
		ENABLE_CLAIM_NOTIFICATIONS: 'CONTACTS.ENABLE_CLAIM_NOTIFICATIONS'
	},
	BONUS: 'PORTAL.BONUS',
	CANCEL: 'PORTAL.CANCEL',
	CDPH530: 'PORTAL.CDPH530.SEND_EMAIL',
	DISPUTES: 'PORTAL.DISPUTES',
	DNR: 'PORTAL.SETTINGS.DNR',
	EDIT: 'PORTAL.EDIT',
	EDIT_ASSIGNMENT: 'PORTAL.EDIT.ASSIGNMENT',
	EDIT_WAGE: 'PORTAL.EDIT.WAGE',
	FACILITY_INFO: 'PORTAL.SETTINGS.FACILITY_INFO',
	GUARANTEE: 'PORTAL.GUARANTEE',
	INVITE: 'PORTAL.SETTINGS.CAREGIVER_INVITE',
	PAST_SHIFTS: 'PORTAL.SHIFTS.PAST',
	PROFESSIONALS: 'PORTAL.FEATURES.PROFESSIONALS',
	INTERNAL_STAFF: 'PORTAL.FLEX.INTERNAL_STAFF',
	SIGNATURE_RULE: 'PORTAL.SETTINGS.SIGNATURE_RULE',
	SETTINGS: 'PORTAL.SETTINGS',
	FLEX_ADD_CAREGIVER: 'PORTAL.FLEX.ADD_CAREGIVER',
	FLEX_ADD_EDIT_SHIFT: 'PORTAL.FLEX.ADD_EDIT_SHIFT',
	ON_CALL_ADD_EDIT_SHIFT: 'PORTAL.ON_CALL.EDIT',
	FLEX_CANCEL: 'PORTAL.FLEX.CANCEL',
	REPORTS: 'REPORTS',
	FLEX_ASSIGN_UNITS: 'PORTAL.FLEX.EDIT.UNIT.ASSIGNMENT',
	PORTAL_EDIT_SHIFT_ROUTING: 'PORTAL.EDIT.SHIFT_ROUTING',
	WORKFORCE_VIEW: 'WORKFORCE_PAGE.ACTION.VIEW',
	WORKFORCE_PROFESSIONAL_EDIT: 'WORKFORCE_PAGE.PROFESSIONAL.EDIT',
	WORKFORCE_PROFESSIONAL_VIEW: 'WORKFORCE_PAGE.PROFESSIONAL.PROFILE.VIEW',
	WORKFORCE_CREDENTIALS_VIEW: 'WORKFORCE.EMPLOYEE.CREDENTIALS.VIEW',
	WORKFORCE_CREDENTIALS_EDIT: 'WORKFORCE.EMPLOYEE.CREDENTIALS.EDIT',
	WORKFORCE_CREDENTIALS_DOWNLOAD: 'WORKFORCE.EMPLOYEE.CREDENTIALS.DOWNLOAD',
	WORKFORCE_DOWNLOAD: 'WORKFORCE_PAGE.ACTION.DOWNLOAD',
	WORKFORCE_CREDENTIALS_DELETE: 'WORKFORCE.EMPLOYEE.CREDENTIALS.DELETE',
	WORKFORCE_LOCATIONS_VIEW: 'WORKFORCE.EMPLOYEE.LOCATIONS.VIEW',
	WORKFORCE_LOCATIONS_EDIT: 'WORKFORCE.EMPLOYEE.LOCATIONS.EDIT',
	WORKFORCE_NOTES_VIEW: 'WORKFORCE.EMPLOYEE.NOTES.VIEW',
	WORKFORCE_NOTES_EDIT: 'WORKFORCE.EMPLOYEE.NOTES.EDIT',
	WORKFORCE_NOTES_DELETE_SUBMITTED: 'WORKFORCE.EMPLOYEE.NOTES.DELETE_SUBMITTED',
	WORKFORCE_NOTES_DELETE_ALL: 'WORKFORCE.EMPLOYEE.NOTES.DELETE_ALL',
	SETTINGS_PAGE_VIEW: 'SETTINGS.PAGE.VIEW',
	SETTINGS_NOTIFICATIONS_EDIT: 'SETTINGS.NOTIFICATIONS.EDIT',
	ON_CALL_SHIFT_MARK_AS_CALLBACK: 'PORTAL.ON_CALL.MARK_AS_CALLBACK',
	WORKFORCE_DOWNLOAD_LOCATIONS: 'WORKFORCE_PAGE.ACTION.DOWNLOAD_LOCATIONS',
	PORTAL_CREATE_FLEX_PAST_SHIFTS: 'PORTAL.FLEX.CREATE_PAST_SHIFTS'
};

export default PERMISSION;
